import { Avatar, AvatarFallback } from '@/shared/components/ui'
import { getIniciaisPrimeiroUltimoNome, StringUtils } from '@/shared/utils'

const IdentificadorClienteAtendimento = ({ nome }: { nome: string }) => {
  return (
    <>
      <Avatar className="size-5 rounded-lg">
        <AvatarFallback className="text-foreground rounded-sm border bg-red-800 text-[0.625rem] font-light">
          {getIniciaisPrimeiroUltimoNome(nome)}
        </AvatarFallback>
      </Avatar>
      <span className="truncate text-sm leading-tight font-medium">{StringUtils.capitalize(nome)}</span>
    </>
  )
}

export { IdentificadorClienteAtendimento }
